import { Route } from 'src/constants/routes';

const titles = {
  [Route.DASHBOARD]: 'Dashboard',
  [Route.DONOR_DASHBOARD]: 'My Dashboard',
  [Route.CONTACTS]: 'Contacts',
  [Route.INVOICES]: 'Invoices',
  [Route.PAYMENTS]: 'Payments',
  [Route.SUBSCRIPTIONS]: 'Subscriptions',
  [Route.FUNDRAISING]: 'Fundraisings',
  [Route.FUNDRAISING_TRANSACTION]: 'Fundraising transactions',
  [Route.SETTINGS]: 'Settings',
  [Route.INVOICES_PAYMENT]: 'Invoices For Payment',
  [Route.INVOICES_CONTACT]: 'Invoices For Contact',
  [Route.PAYMENTS_INVOICE]: 'Payments For Invoice',
  [Route.INVOICES_SUBSCRIPTION]: 'Invoices For Subscription',
  [Route.PAYMENTS_SUBSCRIPTION]: 'Payments For Subscription',
  [Route.PAYMENTS_CONTACT]: 'Payments For Contact',
  [Route.ORGANISATIONS]: 'Organizations',
};

export default titles;
